import AccessState from './AccessContext/AccessState'
import AccessVehiclesState from './AccessVehiclesContext/AccessVehiclesState'
import AccessAreaState from './AccessAreaContext/AccessAreaState'
import AccessPersonToVisitState from './AccessPersonToVisitContext/AccessPersonToVisitState'
import AccessEquipmentState from './AccessEquipment/AccessEquipmentState'

const AccessEgressContext = ({ children }) => {
    return (
        <AccessVehiclesState>
            <AccessAreaState>
                <AccessPersonToVisitState>
                    <AccessEquipmentState>
                        <AccessState>
                            {children}
                        </AccessState>
                    </AccessEquipmentState>
                </AccessPersonToVisitState>
            </AccessAreaState>
        </AccessVehiclesState>
    )
}

export default AccessEgressContext